import React from 'react';
import theme from '../../theme';
import { ThemeProvider } from '@mui/material';
import UserNavbarComponent from '../../components/Navbar/UserNavbarComponent';
import PaymentMethodComponents from '../../components/Card/Payment/PaymentMethodComponents';
import { useLocation } from 'react-router-dom';

const PaymentPage = ({ history }) => {
  const location = useLocation();
  const formData = location.state?.formData;
  const total = location.state?.total;

  const resolveNumericValue = (value) => {
    if (typeof value === "number") {
      return Number.isNaN(value) ? 0 : value;
    }
    if (typeof value === "string") {
      const numericText = value.replace(/,/g, "").replace(/[^\d.]/g, "");
      const numericValue = Number(numericText);
      return Number.isNaN(numericValue) ? 0 : numericValue;
    }
    return 0;
  };

  const calculateTotalAmount = (data) => {
    if (Array.isArray(data)) {
      return data.reduce((sum, item) => {
        const amount = resolveNumericValue(
          item?.Amount ?? item?.unitPrice * item?.quantity
        );
        return sum + amount;
      }, 0);
    }
    if (data && typeof data === "object") {
      return resolveNumericValue(
        data?.Amount ?? data?.unitPrice * data?.quantity
      );
    }
    return 0;
  };

  const resolvedTotal =
    typeof total === "number" && !Number.isNaN(total)
      ? total
      : resolveNumericValue(total) || calculateTotalAmount(formData);


  return (
    <>
      <ThemeProvider theme={theme}>
        <UserNavbarComponent history={history} />
        <PaymentMethodComponents
          history={history}
          formData={formData}
          total={resolvedTotal}
        />
      </ThemeProvider>
    </>
  );
};

export default PaymentPage;
